module.exports = __webpack_public_path__ + "static/media/haachim_thumb.4854f57a.webp";